import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Inicio", path: "/" },
  { label: "Empresa", path: "/empresa" },
  { label: "Servicios", path: "/servicios" },
  { label: "FAQ", path: "/faq" },
  { label: "Contacto", path: "/contacto" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <>
      <header
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
          scrolled ? "bg-white shadow-md" : "bg-transparent"
        }`}
        style={{ fontFamily: "'Montserrat', sans-serif" }}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/db94f5b53595a950c22e6074b38a0d82.jpg"
              alt="GIROBUIT - Vaciado de pisos y locales en Girona"
              className="h-12 w-auto object-contain"
              width={100}
              height={100}
              loading="eager"
              decoding="async"
            />
            <span
              className={`text-lg font-900 tracking-tight whitespace-nowrap transition-colors duration-300 ${
                scrolled ? "text-[#330000]" : "text-white"
              }`}
              style={{ fontWeight: 900 }}
            >
              GIROBUIT
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-600 transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? "text-red-600"
                    : scrolled
                    ? "text-[#330000] hover:text-red-600"
                    : "text-white hover:text-red-300"
                }`}
                style={{ fontWeight: 600 }}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <a
            href="tel:+34602365996"
            className="hidden md:flex items-center gap-2 bg-[#ff0000] text-white px-5 py-2.5 rounded-full text-sm font-700 whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-[#cc0000] hover:scale-105"
            style={{ fontWeight: 700 }}
          >
            <i className="ri-phone-fill text-base"></i>
            Presupuesto Gratis
          </a>

          {/* Hamburger */}
          <button
            className="md:hidden flex items-center justify-center w-10 h-10 cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Abrir menú"
          >
            <i
              className={`text-2xl transition-colors duration-200 ${
                scrolled ? "text-[#330000]" : "text-white"
              } ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}
            ></i>
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 transition-all duration-300 ${
          menuOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
      >
        <div
          className="absolute inset-0 bg-black/50"
          onClick={() => setMenuOpen(false)}
        ></div>
        <div
          className={`absolute top-0 right-0 h-full w-72 bg-[#330000] flex flex-col pt-24 px-8 gap-6 transition-transform duration-300 ${
            menuOpen ? "translate-x-0" : "translate-x-full"
          }`}
        >
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-lg font-600 whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                location.pathname === link.path ? "text-[#ff0000]" : "text-white hover:text-[#FF6666]"
              }`}
              style={{ fontWeight: 600 }}
            >
              {link.label}
            </Link>
          ))}
          <div className="mt-4 flex flex-col gap-3">
            <a
              href="tel:+34602365996"
              className="flex items-center justify-center gap-2 bg-[#ff0000] text-white px-5 py-3 rounded-full text-sm font-700 whitespace-nowrap cursor-pointer"
              style={{ fontWeight: 700 }}
            >
              <i className="ri-phone-fill"></i> Llamar ahora
            </a>
            <a
              href="https://wa.me/34602365996"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-[#25D366] text-white px-5 py-3 rounded-full text-sm font-700 whitespace-nowrap cursor-pointer"
              style={{ fontWeight: 700 }}
            >
              <i className="ri-whatsapp-line"></i> WhatsApp
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
